import { render, staticRenderFns } from "./app-history.vue?vue&type=template&id=5e386499&scoped=true&"
import script from "./app-history.vue?vue&type=script&lang=js&"
export * from "./app-history.vue?vue&type=script&lang=js&"
import style0 from "./app-history.vue?vue&type=style&index=0&id=5e386499&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e386499",
  null
  
)

export default component.exports